import {Pipe, PipeTransform} from '@angular/core';
import {Entity} from '../classes/entity';
import {TtmTypes} from '../classes/ttm-types.enum';

@Pipe({
    name: 'entityZoom'
})
export class EntityZoomPipe implements PipeTransform {

    readonly screenMaxSide = Math.min(window.innerWidth, window.innerHeight);

    transform(entity: Entity, isGnd?: boolean): number {
        if (entity.type === TtmTypes.temporary_road_markings) {
            entity.width = 14;
            entity.height = 14;
        }
        if (!entity.width || !entity.height) {
            return 19;
        }
        let multiplier = 1;
        if (this.screenMaxSide < 1200) {
            multiplier = 2;
        }
        if (this.screenMaxSide < 1000) {
            multiplier = 4;
        }
        if (this.screenMaxSide < 600) {
            multiplier = 6;
        }
        const maxSize = Math.max(entity.width, entity.height) * multiplier;
        if (maxSize > 200 && !isGnd) {
            return 13;
        }
        if (maxSize > 130 && !isGnd) {
            return 14;
        }
        if (maxSize > 80 && !isGnd) {
            return 15;
        }
        if (maxSize > 35) {
            return 16;
        }
        if (maxSize > 20) {
            return 17;
        }
        return 18;

    }

}
